(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', async (event) => {
    const localeButton = event.target.closest('[data-sen-open-localization]');
    if (localeButton) {
      const drawer = localeButton.closest('.sen-header')?.querySelector('header-drawer');
      const menu = drawer?.querySelector('details.menu-drawer-container');
      if (menu && !menu.open) drawer.querySelector('summary.header__icon--menu')?.click();
      setTimeout(() => {
        const selector = drawer?.querySelector('.menu-drawer__localization .localization-form__select');
        selector?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        selector?.focus({ preventScroll: true });
      }, 250);
      return;
    }

    const dialog = document.querySelector('[data-sen-header-wishlist]');
    if (!dialog) return;
    if (event.target.closest('[data-sen-header-wishlist-close]')) {
      dialog.close();
      return;
    }

    const removeButton = event.target.closest('[data-sen-header-wishlist-remove]');
    if (removeButton) {
      try {
        const saved = JSON.parse(localStorage.getItem('the-sen:wishlist:v1') || '[]');
        localStorage.setItem('the-sen:wishlist:v1', JSON.stringify(saved.filter((handle) => handle !== removeButton.dataset.senHeaderWishlistRemove)));
      } catch {}
      removeButton.closest('.sen-shop-card')?.remove();
      if (!dialog.querySelector('[data-sen-header-wishlist-items]').children.length) {
        dialog.querySelector('[data-sen-header-wishlist-status]').textContent = JSON.parse(dialog.querySelector('[data-sen-header-wishlist-labels]').textContent).empty;
      }
      return;
    }

    if (!event.target.closest('[data-sen-wishlist-open]') || document.querySelector('sen-product-ui')) return;
    const labels = JSON.parse(dialog.querySelector('[data-sen-header-wishlist-labels]').textContent);
    const status = dialog.querySelector('[data-sen-header-wishlist-status]');
    const items = dialog.querySelector('[data-sen-header-wishlist-items]');
    let saved = [];
    try {
      const values = JSON.parse(localStorage.getItem('the-sen:wishlist:v1') || '[]');
      if (Array.isArray(values)) saved = values.filter((handle) => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle)).slice(0, 50);
    } catch {}
    items.replaceChildren();
    status.textContent = saved.length ? labels.loading : labels.empty;
    dialog.showModal();
    if (!saved.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const cards = await Promise.all(saved.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=sen-product-tile`);
        if (!response.ok) return null;
        const html = await response.text();
        const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.sen-shop-card');
        if (!card) return null;
        card.querySelector('[data-sen-wishlist]')?.remove();
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sen-header-wishlist__remove';
        remove.dataset.senHeaderWishlistRemove = handle;
        remove.textContent = labels.remove;
        card.append(remove);
        return card;
      } catch { return null; }
    }));
    if (!dialog.open) return;
    items.replaceChildren(...cards.filter(Boolean));
    status.textContent = items.children.length ? '' : labels.error;
  });

  } catch(e) { console.error(e); }
})();
})();
